import React, { Component } from 'react';
import { Message } from 'primereact/message';
import { Growl } from 'primereact/growl';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import Moment from 'react-moment';
import { Button } from 'primereact/button';
import servicioCfdi from '../servicios/ServicioCfdi';
import servicioArchivos from '../servicios/ServicioArchivos';
import { Dropdown } from 'primereact/dropdown';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioPagos from '../servicios/ServicioPagos';
import servicioDescargaArchivos from '../servicios/ServicioArchivos';
import { Calendar } from 'primereact/calendar';
import { ConsultaComprobantePago } from './ConsultaComprobantePago';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import servicioFormatos from '../servicios/ServicioFormatos';
import CurrencyFormat from 'react-currency-format';
import Dropzone from 'react-dropzone';
import {ScrollPanel} from 'primereact/scrollpanel';
export class ConsultaFacturasOrigen extends Component {
  constructor() {
    super();
    this.state = {
      listaResultados: [],
      mostrarModalResultado: false,
      cfdis: [],
      paginacion: { registrosPorPagina: 20
      },
      inicio: 0,
      criterio: {},
      mostrarMoldalFacturaPagos: false,
      erroresRequeridos: {},
      formaPago: {},
      erroresFormulario: {},
      pago: {},
      comprobante: {},
      facturaPadre: {},
      receptorPadre: {},
      urlDescargaArchivosFacturacion: 'documentos/descargarzip.json',
      moneda: [
        { name: 'MXN', code: 'MXN', validacion: '2' },
        { name: 'USD', code: 'USD', validacion: '2' }
      ],
      formaPagos: [
        { name: '01-Efectivo', code: '01' },
        { name: '02-Cheque nominativo', code: '02' },
        { name: '03-Transferencia electrónica de fondos', code: '03' },
        { name: '04-Tarjeta de crédito', code: '04' },
        { name: '05-Monedero electrónico', code: '05' },
        { name: '06-Dinero electrónico', code: '06' },
        { name: '08-Vales de despensa', code: '07' },
        { name: '12-Dación en pago', code: '12' },
        { name: '13-Pago por subrogación', code: '13' },
        { name: '14-Pago por consignación', code: '14' },
        { name: '15-Condonación', code: '15' },
        { name: '17-Compensación', code: '17' },
        { name: '23-Novación', code: '23' },
        { name: '24-Confusión', code: '24' },
        { name: '25-Remisión de deuda', code: '25' },
        { name: '26-Prescripción o caducidad', code: '26' },
        { name: '27-A satisfacción del acreedor', code: '27' },
        { name: '28-Tarjeta de débito', code: '28' },
        { name: '29-Tarjeta de servicios', code: '29' },
        { name: '30-Aplicación de anticipos', code: '30' },
        { name: '31-Intermediario pagos', code: '31' },
        { name: '99-Por definir', code: '99' }
      ],
      datosSpei: [{ name: "01 SPEI", code: "01",validacion:'3' }],
      spei: {},

      validacionFormaPago: {},
      validacionMoneda: {},
      validacionSpei:{}
    }
    this.llenar = this.llenar.bind(this);
    this.buscarLinkPagos = this.buscarLinkPagos.bind(this);
  }
  onDropDos = (files) => {
    console.log(files.length);
    let formData = new FormData();
    for (var i = 0; i < files.length; i++) {
      var cfdi = files[i];
      formData.append('file', cfdi);
    }
    servicioPagos.procesar_factura(formData).then((response) => {
      this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
      this.setState({ mostrarMensaje: false });
      this.obtenerPagina();
    }).catch((error) => {

    });


  }
  componentDidMount() {
    this.obtenerPagina();

  }
  cambiaPagina(event) {
    let { paginacion } = this.state;

    paginacion.numeroPagina = event.page;
    paginacion.registrosPorPagina = event.rows;
    this.setState({ inicio: event.first, paginacion });
    this.obtenerPagina();
  }
  obtenerPagina() {
    let { paginacion } = this.state;
    servicioCfdi.paginacion_pagos_ppd(paginacion).then((response) => {
      this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });

      if (response.data.error === false)
        this.setState({ paginacion: response.data.objeto });


    }).catch((error) => {
      if (error)
        return this.growl.show({ life: 4000, severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
    });

  }
  generaDescarga(objeto, tipo) {
    servicioArchivos.descargaArchivo('/documentos/descargar_documentos.json?uuid=' + objeto.ttCfdi.uuid + '&tipo=' + tipo);

  }
  descargaRepresentacionImpresa = (rowData, column) => {
    return <div>
      <div>
        <Button type="button" icon="pi-md-file-download" className="p-button-danger" name="pdf"
          tooltip="Descargar pdf" onClick={(e) => this.generaDescarga(column.rowData, 'pdf')} >
        </Button>
      </div>
    </div>;
  }
  botonPago = (rowData, column) => {
    return <div>
      <div>
        <Button type="button" icon="pi-md-plus" className="p-button-success" name="pago"
          tooltip="generar pago" onClick={(e) => this.prefacturar(column.rowData)} >
        </Button>
      </div>
    </div>;
  }
  botonBuscar = (rowData, column) => {
    return <div>
      <div>
        <Link to={{
          pathname: "/Capufe/bienvenido/consultapago",
          state: { id: column.rowData }
        }} onClick={this.llenar.bind(this, column.rowData)}> <Button type="button" icon="pi-md-search" /></Link>

      </div>
    </div>;
  }
  descargaXmlSaT = (rowData, column) => {

    return <div>
      <div className="p-col-12 p-md-4">
        <Button type="button" icon="pi-md-file-download" className="p-button-success" name="xml"
          tooltip="Descargar xml" onClick={(e) => this.generaDescarga(column.rowData, 'xml')} >
        </Button>
      </div>
    </div>;
  }
  formatofechaCreacion = (rowData, column) => {
    return <Moment format="YYYY-MM-DD HH:mm:ss">
      {rowData.ttCfdi.fechaCreacion}
    </Moment>;
  }
  columnaEstatus = (rowData, column) => {
    if (rowData.ttCfdi.estado === 1)
      return <p>Activo</p>
    if (rowData.ttCfdi.estado === 0)
      return <p>Cancelado</p>
  }
  prefacturar = (rowData) => {

    this.setState({ mostrarMoldalFacturaPagos: true, comprobante: rowData, facturaPadre: rowData.ttCfdi, receptorPadre: rowData.tcReceptor });


  }
  facturar = () => {
    let { comprobante } = this.state;
    const { pago } = this.state;
    const validacion = this.validarFormulario(pago);
    this.setState({ erroresFormulario: validacion });
    if (!Object.keys(validacion).length) {

      var pagoEnvio = JSON.parse(JSON.stringify(pago));
      let monedaP = pagoEnvio.monedaP.code;
      let formaDePagoP = pagoEnvio.formaDePagoP.code;
      if(pagoEnvio.tipoCadPago!=null){
      let tipoCadPago = pagoEnvio.tipoCadPago.code;
      pago.tipoCadPago = tipoCadPago;
      }
      pago.monedaP = monedaP;
      pago.formaDePagoP = formaDePagoP;
      const documentoRelacionado = [{}];
      pago.doctoRelacionado = documentoRelacionado;
      const certPago = pago.certPago;
      const selloPago = pago.selloPago;
      delete pago['certPago'];
      delete pago['selloPago'];
      let wrapper = { trFacturacion: comprobante, pago, certPago,selloPago};
      servicioPagos.facturar_comprobante_pago(wrapper).then((response) => {
        let respuesta = response.data;        
        this.setState({ listaResultados: respuesta.lista });

        this.setState({ facturaPadre: {}, receptorPadre: {}, mostrarModalResultado: true, mostrarMoldalFacturaPagos: false, pago: {},validacionFormaPago:{},validacionMoneda:{},validacionSpei:{} });
        this.obtenerPagina();


      }).catch((error) => {
        this.setState({ mostrarModalResultado: true, mostrarMoldalFacturaPagos: false, pago: {} });
      });
    }
  }

  validarFormulario = (objeto) => {
    const errores = {};
    let { facturaPadre } = this.state;
    const validarTotal = facturaPadre.total - facturaPadre.totalPagado;
    var expreReg = /^\d*(\.\d{1})?\d{1,1}$/;
    var RE = /^\d*\.?\d*$/;
    var validacionDecimal = RE.exec(objeto.monto);
    var validaMonto = expreReg.exec(objeto.monto);
    if (!objeto.formaDePagoP)
      errores.formaDePagoP = "El campo es requerido";
    if (!objeto.monedaP)
      errores.monedaP = "El campo es requerido";
    if (!objeto.monto)
      errores.monto = "El campo es requerido";
    if (!validaMonto)
      errores.monto = "El número de decimales es el que soporta los decimales";
     if (!validacionDecimal)
      errores.monto = "El número de decimales es el que soporta los decimales";
    if (!objeto.fechaPago)
      errores.fechaPago = "El campo es requerido";
    if (objeto.monto > validarTotal)
      errores.monto = "El campo monto supera el total pagado de la factura";
    return errores;
  };

  formatoTipoComprobante(rowData, column) {
    let tipo = rowData.ttCfdi.tipoComprobante;
    let valor = "";
    switch (tipo) {
      case 0:
        valor = "Factura de pagos ";
        break;
      case 1:
        valor = "Factura de emergencia";
        break;
      case 2:
        valor = "Factura de Peaje";
        break;
      case 3:
        valor = "Factura reexpedida";
        break;
      case 4:
        valor = "Ingresos diversos";
        break;
      case 5:
        valor = "Ingresos diversos/Nota de crédito";
        break;
      case 6:
        valor = "Nota de crédito";
        break;
      default:
        valor = "";
    }
    return <div>
      {valor}
    </div>;
  }
  asignarValoresObjeto = (event) => {

    if (event.value !== undefined) {
      let { validacionFormaPago, validacionMoneda,validacionSpei } = this.state;
      if (event.value.validacion === 1) {
        validacionFormaPago.code = event.value.code;
      }
      if (event.value.validacion === 2) {
        validacionMoneda.code = event.value.code;
      }
      if (event.value.validacion === 3) {
        validacionSpei.code = event.value.code;
      }

    }


    if (event.target.id === "usoCfdi" || event.target.id === "correo")
      servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
    else
      servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
  }
  cerrarModalResultados = () => {
    this.setState({ mostrarModalResultado: false });
  }
  templateDescargaArchivos = (rowData, column) => {
    if (rowData.error === false)
    return <div>
      <Button type="button" icon="pi-md-cloud-download" className="p-button-success" onClick={(e) => this.descargaArchivos(rowData)}></Button>
    </div>;
  }
  descargaArchivos = (rowData) => {
    let { urlDescargaArchivosFacturacion } = this.state;
    servicioDescargaArchivos.descargaArchivo(urlDescargaArchivosFacturacion, { id: rowData.busqueda });
  }
  templateErrorResultado = (rowData, column) => {
    if (rowData.error === true)
      return <div className="p-col-12 p-md-2"><i className="pi-md-cancel"></i></div>;
    else
      return <div className="p-col-12 p-md-2"><i className="pi-md-check-circle"></i></div>;
  }
  llenar(objeto) {
    console.log(objeto.id);
    return <div className="CfdiPagos">
      <ConsultaComprobantePago id={objeto.id} app="Mi App React" />
    </div>
  }
  buscarLinkPagos(rowData, column) {
    return <div>
      <Link to={{
        pathname: "/Capufe/bienvenido/consultapago",
        state: { id: column.rowData }
      }} onClick={this.llenar.bind(this, column.rowData)}></Link>

    </div>;
  }
  columnaTotal = (rowData, column) => {
    return <div>{servicioFormatos.formatearModena(rowData.ttCfdi.total)}</div>;
  }
  columnaTotalPagado = (rowData, column) => {
    return <div>{servicioFormatos.formatearModena(rowData.ttCfdi.totalPagado)}</div>;
  }
  render() {
    const {validacionSpei, datosSpei, receptorPadre, validacionFormaPago, validacionMoneda, listaResultados, mostrarModalResultado, inicio, paginacion, erroresFormulario, pago, moneda, facturaPadre } = this.state;
    const dialogFooter = (
      <div>
        <Button icon="pi-md-check" onClick={this.facturar} label="Facturar" className="teal-btn flat-btn" />
        <Button icon="pi-md-close" onClick={() => this.setState({ mostrarMoldalFacturaPagos: false, erroresRequeridos: {} })} label="Cancelar" className="p-button-danger flat-btn" />
      </div>
    );
    const piePaginaModalRestultados = (
      <div>
        <Button label="Cerrar" icon="pi pi-times" onClick={this.cerrarModalResultados} />
      </div>
    );
    const formasPagos = [
      { name: '01-Efectivo', code: '01', validacion: '1' },
      { name: '02-Cheque nominativo', code: '02', validacion: '1' },
      { name: '03-Transferencia electrónica de fondos', code: '03', validacion: '1' },
      { name: '04-Tarjeta de crédito', code: '04', validacion: '1' },
      { name: '05-Monedero electrónico', code: '05', validacion: '1' },
      { name: '06-Dinero electrónico', code: '06', validacion: '1' },
      { name: '08-Vales de despensa', code: '07', validacion: '1' },
      { name: '12-Dación en pago', code: '12', validacion: '1' },
      { name: '13-Pago por subrogación', code: '13', validacion: '1' },
      { name: '14-Pago por consignación', code: '14', validacion: '1' },
      { name: '15-Condonación', code: '15', validacion: '1' },
      { name: '17-Compensación', code: '17', validacion: '1' },
      { name: '23-Novación', code: '23', validacion: '1' },
      { name: '24-Confusión', code: '24', validacion: '1' },
      { name: '25-Remisión de deuda', code: '25', validacion: '1' },
      { name: '26-Prescripción o caducidad', code: '26', validacion: '1' },
      { name: '27-A satisfacción del acreedor', code: '27', validacion: '1' },
      { name: '28-Tarjeta de débito', code: '28', validacion: '1' },
      { name: '29-Tarjeta de servicios', code: '29', validacion: '1' },
      { name: '30-Aplicación de anticipos', code: '30', validacion: '1' },
      { name: '31-Intermediario pagos', code: '31', validacion: '1' },
      { name: '99-Por definir', code: '99', validacion: '1' }
    ];


    return (
      <div>
        <Growl ref={(el) => this.growl = el} />
        <div className="content-section implementation">
          <div className="card card-w-title">
            <div className="p-grid p-fluid">
              <div className="p-col-12  p-md-4">
                <Link to={{
                  pathname: "/Capufe/bienvenido/pagos",
                  state: {}
                }} >
                  <Button label="Facturas de pago Origen" className="blue-grey-btn flat-btn" />
                </Link>
              </div>
              <div className="p-col-12  p-md-4">
                <Link to={{
                  pathname: "/Capufe/bienvenido/adminPagos",
                  state: {}
                }} > <Button label="Facturas de Recepción de pago" className="blue-grey-btn flat-btn" ></Button> </Link>
              </div>



            </div>
            <h1>Crear factura de recepción de pagos</h1>
            <div className="p-col-12 p-md-12">
              <Dropzone maxSize={10000000} accept=".xml" onDrop={this.onDropDos}>
                {({ getRootProps, getInputProps }) => (
                  <section className="container">
                    <div  {...getRootProps({ className: 'dropzone rectangulo' })}>
                      <input   {...getInputProps()} />
                      <center><p>Arrastra aqui tus facturas origen</p></center>
                    </div>
                    <br></br>

                    <aside>

                    </aside>

                  </section>
                )}
              </Dropzone>
            </div>
          </div>
          <Dialog header="Factura de recepción de pagoss" scroll visible={this.state.mostrarMoldalFacturaPagos} modal={true} footer={dialogFooter} style={{ width: '60vw' }} onHide={() => this.setState({ receptor: {}, mostrarMoldalFacturaPagos: false, erroresRequeridos: {} })}>
          <ScrollPanel style={{width: '100%', height: '300px'}}>
            <div className="content-section implementation">
              <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-3">
                  <h4>Rfc Cliente:</h4>
                  <label htmlFor="input">{receptorPadre.rfc}</label>
                </div>
                <div className="p-col-12 p-md-3">
                  <h4>Folio Fiscal:</h4>
                  <label htmlFor="input">{facturaPadre.uuid}</label>
                </div>

                <div className="p-col-12 p-md-3">
                  <h4>Folio:</h4>
                  <label htmlFor="input">{facturaPadre.folio}</label>
                </div>

                <div className="p-col-12 p-md-3">
                  <h4>Serie:</h4>
                  <label htmlFor="input">{facturaPadre.serie}</label>
                </div>


              </div>
              <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-3">
                  <h4>Total General:</h4>
                  <label htmlFor="input">
                    <CurrencyFormat value={facturaPadre.total} fixedDecimalScale={true} decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={'$'} /></label>
                </div>
                <div className="p-col-12 p-md-3">
                  <h4>Total Pagado:</h4>
                  <label htmlFor="input">
                    <CurrencyFormat value={facturaPadre.totalPagado} fixedDecimalScale={true} decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={'$'} /></label>
                </div>
                <div className="p-col-12 p-md-3">
                  <h4>Total Restante:</h4>
                  <label htmlFor="input">
                    <CurrencyFormat value={facturaPadre.total - facturaPadre.totalPagado} fixedDecimalScale={true} decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={'$'} /></label>
                </div>
                <div className="p-col-12 p-md-3">
                  <h4>No. Parcialidades Realizadas:</h4>
                  <label htmlFor="input">{facturaPadre.parcialidad}</label>
                </div>
              </div>
              <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-12">
                  <label htmlFor="input">Datos Generales de Recepción de Pagos:</label>
                </div>
                <div className="p-col-12 p-md-4">
                  <h4>* Forma de pago:</h4>
                  <Dropdown id="formaDePagoP" name="pago.formaDePagoP" options={formasPagos} value={pago.formaDePagoP} onChange={this.asignarValoresObjeto} placeholder="Selecciona" optionLabel="name" className={erroresFormulario.formaDePagoP ? 'p-error' : ''} />
                  {erroresFormulario.formaDePagoP ? <div> <Message severity="error" text={erroresFormulario.formaDePagoP} /> </div> : null}
                </div>
                <div className="p-col-12 p-md-4">
                  <h4>* Moneda:</h4>
                  <Dropdown id="monedaP" name="pago.monedaP" options={moneda} value={pago.monedaP} onChange={this.asignarValoresObjeto} placeholder="Selecciona" optionLabel="name" className={erroresFormulario.monedaP ? 'p-error' : ''} />
                  {erroresFormulario.monedaP ? <div> <Message severity="error" text={erroresFormulario.monedaP} /> </div> : null}
                </div>
                {validacionMoneda.code !== "MXN" && validacionMoneda.code !== undefined ?
                  <div className="p-col-12 p-md-4">
                    <h4>Tipo Cambio:</h4>
                    <InputText id="pago.tipoCambioP" name="pago.tipoCambioP" value={pago.tipoCambioP || ''} onChange={this.asignarValoresObjeto} className={erroresFormulario.tipoCambioP ? 'p-error' : ''} />
                    {erroresFormulario.tipoCambioP ? <div> <Message severity="error" text={erroresFormulario.tipoCambioP} /> </div> : null}
                  </div>
                  : null}
              </div>
              <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-4">
                  <h4>* Monto*:</h4>
                  <InputText id="monto" name="pago.monto" value={pago.monto || ''} onChange={this.asignarValoresObjeto} className={erroresFormulario.monto ? 'p-error' : ''} />
                  {erroresFormulario.monto ? <div> <Message severity="error" text={erroresFormulario.monto} /> </div> : null}
                </div>
                <div className="p-col-12 p-md-4">
                  <h4> Num. Operación:</h4>
                  <InputText id="numOperacion" name="pago.numOperacion" value={pago.numOperacion || ''} onChange={this.asignarValoresObjeto} className={erroresFormulario.numOperacion ? 'p-error' : ''} />
                  {erroresFormulario.numOperacion ? <div> <Message severity="error" text={erroresFormulario.numOperacion} /> </div> : null}
                </div>
              </div>
              <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-4">
                  <h4>Fecha de creación:</h4>
                  <Calendar id="fechaPago" name="pago.fechaPago" value={pago.fechaPago || ''} onChange={this.asignarValoresObjeto} className={erroresFormulario.fechaPago ? 'p-error' : ''} dateFormat="yy-mm-dd" showTime={true} showSeconds={true} />
                  {erroresFormulario.fechaPago ? <div><br /> <Message severity="error" text={erroresFormulario.fechaPago} /> </div> : null}
                </div>
              </div>

              {validacionFormaPago.code === "03" ?
                <div className="p-grid p-fluid">
                  <div className="p-col-12 p-md-4">

                    <h4> Rfc Emisor Cta. Ordenante:</h4>
                    <InputText id="rfcEmisorCtaOrd" name="pago.rfcEmisorCtaOrd" value={pago.rfcEmisorCtaOrd || ''} onChange={this.asignarValoresObjeto} className={erroresFormulario.rfcEmisorCtaOrd ? 'p-error' : ''} />
                    {erroresFormulario.rfcEmisorCtaOrd ? <div> <Message severity="error" text={erroresFormulario.rfcEmisorCtaOrd} /> </div> : null}

                  </div>
                  <div className="p-col-12 p-md-4">

                    <h4> Cta. Ordenante:</h4>
                    <InputText id="ctaOrdenante" name="pago.ctaOrdenante" value={pago.ctaOrdenante || ''} onChange={this.asignarValoresObjeto} className={erroresFormulario.ctaOrdenante ? 'p-error' : ''} />
                    {erroresFormulario.ctaOrdenante ? <div> <Message severity="error" text={erroresFormulario.ctaOrdenante} /> </div> : null}

                  </div>
                </div>
                : null}
              {validacionFormaPago.code === "03" ?
                <div className="p-grid p-fluid">
                  <div className="p-col-12 p-md-4">

                    <h4> Rfc Emisor Cuenta Beneficiario:</h4>
                    <InputText id="rfcEmisorCtaBen" name="pago.rfcEmisorCtaBen" value={pago.rfcEmisorCtaBen || ''} onChange={this.asignarValoresObjeto} className={erroresFormulario.rfcEmisorCtaBen ? 'p-error' : ''} />
                    {erroresFormulario.rfcEmisorCtaBen ? <div> <Message severity="error" text={erroresFormulario.rfcEmisorCtaBen} /> </div> : null}

                  </div>
                  <div className="p-col-12 p-md-4">

                    <h4> Cuenta Beneficiario:</h4>
                    <InputText id="ctaBeneficiario" name="pago.ctaBeneficiario" value={pago.ctaBeneficiario || ''} onChange={this.asignarValoresObjeto} className={erroresFormulario.ctaBeneficiario ? 'p-error' : ''} />
                    {erroresFormulario.ctaBeneficiario ? <div> <Message severity="error" text={erroresFormulario.ctaBeneficiario} /> </div> : null}

                  </div>
                </div>

                : null}
                 {validacionFormaPago.code === "03" ?
              <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-4">
                  <h4>Tipo De Cadena De Pago:</h4>
                  <Dropdown id="tipoCadPago" name="pago.tipoCadPago" options={datosSpei} value={pago.tipoCadPago} onChange={this.asignarValoresObjeto} placeholder="Selecciona" optionLabel="name" className={erroresFormulario.tipoCadPago ? 'p-error' : ''} />
                  {erroresFormulario.tipoCadPago ? <div> <Message severity="error" text={erroresFormulario.tipoCadPago} /> </div> : null}
                </div>
              </div>
              :null}
              {validacionSpei.code === "01" ?
              <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-4">
                  <h4> Certificado Que Corresponde Al Pago:</h4>
                  <InputText id="certPago" name="pago.certPago" value={pago.certPago || ''} onChange={this.asignarValoresObjeto} className={erroresFormulario.certPago ? 'p-error' : ''} />
                    {erroresFormulario.certPago ? <div> <Message severity="error" text={erroresFormulario.certPago} /> </div> : null}

                </div>
                <div className="p-col-12 p-md-4">
                  <h4>  Cadena Original Del Comprobante De Pago:</h4>
                  <InputText id="cadPago" name="pago.cadPago" value={pago.cadPago || ''} onChange={this.asignarValoresObjeto} className={erroresFormulario.cadPago ? 'p-error' : ''} />
                    {erroresFormulario.cadPago ? <div> <Message severity="error" text={erroresFormulario.cadPago} /> </div> : null}

                </div>
                <div className="p-col-12 p-md-4">
                  <h4>  Sello Digital Que Se Asocie Al Pago:</h4>
                  <InputText id="selloPago" name="pago.selloPago" value={pago.selloPago || ''} onChange={this.asignarValoresObjeto} className={erroresFormulario.selloPago ? 'p-error' : ''} />
                    {erroresFormulario.selloPago ? <div> <Message severity="error" text={erroresFormulario.selloPago} /> </div> : null}

                </div>
              </div>
              :null}

            </div>
            </ScrollPanel>
          </Dialog>
          <DataTable value={paginacion.datos} editable={true} scrollable={true} scrollHeight="280px"  >
            <Column header="Pago" body={this.botonPago.bind(this)} style={{ width: '100px' }} />
            <Column header="Buscar" body={this.botonBuscar.bind(this)} style={{ width: '100px' }} />
            <Column header="Descarga Pdf" body={this.descargaRepresentacionImpresa.bind(this)} style={{ width: '100px' }} />
            <Column header="Descarga Xml" body={this.descargaXmlSaT.bind(this)} style={{ width: '100px' }} autoLayout={true} />
            <Column field="ttCfdi.estado" body={this.columnaEstatus.bind(this)} header="Estado" style={{ width: '200px' }} filter={false} autoLayout={true} />
            <Column field="ttCfdi.total" body={this.columnaTotal} header="Total" style={{ width: '200px' }} filter={false} autoLayout={true} />
            <Column field="ttCfdi.parcialidad" header="Pago" style={{ width: '200px' }} filter={false} autoLayout={true} />
            <Column field="ttCfdi.totalPagado" body={this.columnaTotalPagado} header="Total Pagado" style={{ width: '200px' }} filter={false} autoLayout={true} />
            <Column field="ttCfdi.uuid" header="Folio fiscal" style={{ width: '200px' }} filter={false} autoLayout={true} />


          </DataTable>
          <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
          <Dialog header="Resultado facturación" visible={mostrarModalResultado} style={{ width: '50vw' }} modal={true} closeOnEscape={false} closable={false} footer={piePaginaModalRestultados} onHide={this.cerrarModalResultados}>
            <DataTable value={listaResultados} header="Facturas generadas" responsive={true}>
              <Column body={this.templateErrorResultado} header="Estado" />
              <Column field="mensaje" header="Observación" />
              <Column field="uuid" header="UUID" />
              <Column field="serie" header="Serie" />
              <Column field="folio" header="Folio" />
              <Column body={this.templateDescargaArchivos} style={{ textAlign: 'center', width: '8em' }} header="Descargar archivos" />
            </DataTable>
          </Dialog>

        </div>

      </div>
    );
  }

}